import { Component, OnInit } from "@angular/core";
import { NavService, Menu } from "../../services/nav.service";
import { Router } from "@angular/router";
import { forkJoin } from "rxjs";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
})
export class MenuComponent implements OnInit {
  public llenarMenu: boolean = false;
  public menuItems: Menu[] = [
    {
      title: 'INICIO',
      type: 'link',
      path: '/home/watch',
    },
    {
      title: 'CONTACTO',
      type: 'link',
      path: '/pages/contact',
    },
    {
      title: "Productos",
      type: "sub",
      active: false,
      children: [],
    },
  ];

  constructor(private router: Router, public navServices: NavService) {
    // Usamos forkJoin para esperar a que ambas llamadas asíncronas completen
    forkJoin([
      this.navServices.listarCategorias(),
      this.navServices.listarSubcategorias()
    ]).subscribe(([categorias, subcategorias]) => {
      // Procesamos las categorías
      Object.values(categorias).forEach((categoria: any) => {
        if (categoria.categoria.toLowerCase() === "salud") {
          categoria.categoria = "Bienestar";
        }
        if (categoria.estatus === 1) {
          this.menuItems[2].children.push({
            id: categoria.id,
            title: categoria.categoria,
            type: "sub",
            active: false,
          });
        }
      });

      // Procesamos las subcategorías
      const subcategoriasPorCategoria: { [key: string]: any[] } = {};
      Object.values(subcategorias).forEach((subcategoria: any) => {
        if (!subcategoriasPorCategoria[subcategoria.idCategoria]) {
          subcategoriasPorCategoria[subcategoria.idCategoria] = [];
        }
        subcategoriasPorCategoria[subcategoria.idCategoria].push(subcategoria);
      });

      this.menuItems[2].children.forEach((hijo: any) => {
        if (subcategoriasPorCategoria[hijo.id]) {
          if (!hijo.children) {
            hijo.children = [];
          }
          subcategoriasPorCategoria[hijo.id].forEach((subcategoria: any) => {
            if (subcategoria.estatus === 1) {
              hijo.children.push({
                path: `/shop/collection/left/sidebar/${this.transformCategoryForRoute(
                  subcategoria.subcategoria
                )}`,
                title: subcategoria.subcategoria,
                type: "link",
              });
            }
          });
        }
      });

      // Establecemos llenarMenu en true cuando todas las operaciones asíncronas hayan finalizado
      this.llenarMenu = true;
    });

    this.router.events.subscribe((event) => {
      this.navServices.mainMenuToggle = false;
    });
  }

  ngOnInit(): void {}

  mainMenuToggle(): void {
    this.navServices.mainMenuToggle = !this.navServices.mainMenuToggle;
  }

  closeMenu(): void {
    this.navServices.mainMenuToggle = true;
  }

  toggletNavActive(item) {
    item.active = !item.active;
  }

  transformCategoryForRoute(subcategoria: string): string {
    return subcategoria.toLowerCase().replace(/\s/g, "-");
  }
}
